import React from "react";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/react-hooks";
import { BrowserRouter } from "react-router-dom";

import { getStore } from "shared/redux/addToGlobalStore";
import getApolloClient from "shared/util/getApolloClient";

import setupStore from "./Store/setup";
import Page from "./Page";

const Desktop = () => {
	setupStore();

	return (
		<Provider store={getStore()}>
			<ApolloProvider client={getApolloClient()}>
				<BrowserRouter>
					<Page />
				</BrowserRouter>
			</ApolloProvider>
		</Provider>
	);
};

export default Desktop;



// WEBPACK FOOTER //
// ./src/routers/Desktop/index.jsx